/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_TitleInputs */



/**
* | output |
* | --- |
* | "Folder Permissions" |
*
* @param {Explorer_Info_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_title = /** @type {((inputs?: Explorer_Info_Permissions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations du dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordnerberechtigungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizzazioni cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Права доступа к папкам")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos de carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹权限")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダ権限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर अनुमतियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões de pasta")
	return /** @type {LocalizedString} */ ("Folder Permissions")
});